import memoize from '@core/lodash/memoize';
import mergeWith from '@core/lodash/mergeWith';
import uniq from '@core/lodash/uniq';
const emptyProduct = () => ({
    id: '',
    business_store_id: 0,
    business_store_name: '',
    business_store_uid: '',
    custom_cta_target: '',
    custom_cta_title: null,
    custom_cta_title_translation: null,
    custom_cta_url: null,
    hide_primary_cta: false,
    hidden: false,
    product_currency: '',
    product_currency_symbol: '',
    product_description: '',
    product_subtitle: '',
    product_id: '',
    product_ext_id: '',
    product_handle: '',
    product_hide_price: false,
    product_images: [],
    product_name: '',
    product_options: [],
    product_shipping: '',
    selected_product_unit_id: '',
    product_units: [],
    vendor_id: '',
    vendor_name: '',
});
/**
 * When merging `srcValue` into `objValue`, do it only if `srcValue` (hydrated) is not empty
 * or starts with `__` as our autogenerated uuids do.
 */
const customizerEmpty = (objValue, srcValue, key) => {
    if (key &&
        objValue &&
        (!srcValue || (srcValue?.startsWith && srcValue.startsWith('__')))) {
        return objValue;
    }
};
const customizer = (objValue, srcValue, key) => {
    const compare = {
        product_images: ['image_ext_id'], // 'image_id'],
        product_units: ['unit_ext_id'], // , 'unit_id']
    };
    const compareBy = compare[key];
    if (compareBy) {
        const objValueByExt = objValue.reduce((acc, curr) => {
            const key = compareBy.map((k) => curr[k]).filter(Boolean)[0];
            if (key) {
                acc[String(key)] = curr;
            }
            return acc;
        }, {});
        const srcValueByExt = srcValue.reduce((acc, curr) => {
            const key = compareBy.map((k) => curr[k]).filter(Boolean)[0];
            if (key) {
                acc[String(key)] = curr;
            }
            return acc;
        }, {});
        const keys = uniq([
            ...Object.keys(objValueByExt),
            ...Object.keys(srcValueByExt),
        ]);
        const result = keys.map((k) => mergeWith({}, objValueByExt[k] || {}, srcValueByExt[k] || {}, customizerEmpty));
        // we should override the whole unit option instead of merging if custom unit options are provided
        if (key === 'product_units') {
            return result.map((r) => {
                return {
                    ...r,
                    unit_options: srcValueByExt[r.unit_ext_id] &&
                        srcValueByExt[r.unit_ext_id].unit_options.length
                        ? srcValueByExt[r.unit_ext_id].unit_options
                        : objValueByExt[r.unit_ext_id]
                            ? objValueByExt[r.unit_ext_id].unit_options
                            : [],
                };
            });
        }
        else {
            return result;
        }
    }
    return customizerEmpty(objValue, srcValue, key);
};
/**
 *
 */
export const mergeProducts = (product1, product2) => {
    return mergeWith(emptyProduct(), product1 || {}, product2 || {}, customizer);
};
/**
 *
 */
export const mergeProductsWithHydrated = memoize((products, productsHydrated) => {
    return products.map((product) => {
        const productHydrated = productsHydrated[product.product_ext_id];
        return productHydrated ? mergeProducts(product, productHydrated) : product;
    });
}, (...args) => JSON.stringify(args));
